/** Portuguese org-admin UI copy (sidebar, tabs, dialogs, billing tab). */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const accountAdminCopyPt = {
  backToSite: '← Voltar ao site',
  ORG_DRAWER_PARENT_FALLBACK: 'Organizações',
  FRIENDS_ENTRY_LABEL: 'Gerir organização',
  FRIENDS_ENTRY_HINT: 'Marca e membros',
  START_HERE: 'Começar aqui',
  START_HERE_INTRO:
    'Use a navegação da organização para alternar entre Começar aqui, Marca, Membros e Definições. Depois:',
  OPEN_MENU: 'Abrir menu',
  BRANDING: 'Marca',
  MEMBERS: 'Membros',
  SETTINGS: 'Definições',
  PLAN_BILLING: 'Plano',
  PLAN_BILLING_INTRO:
    'Atualize a sua organização na web, gere métodos de pagamento e veja faturas no portal de clientes Stripe.',
  PLAN_BILLING_CURRENT: 'Plano atual',
  PLAN_BILLING_RENEWS: 'Renova ou termina o período',
  PLAN_BILLING_STATUS: 'Estado da subscrição',
  PLAN_BILLING_UPGRADE_BUSINESS: 'Atualizar para Business',
  PLAN_BILLING_UPGRADE_ENTERPRISE: 'Atualizar para Enterprise',
  PLAN_BILLING_PORTAL: 'Gerir faturação e faturas',
  PLAN_BILLING_WEB_ONLY: 'Os planos estão disponíveis na web.',
  INVOICE_DETAILS: 'Faturação e fatura',
  INVOICE_DETAILS_WEB_ONLY: 'Faturação e fatura estão disponíveis na web.',
  MANAGE_PLAN_BILLING: 'Gerir plano',
  COMPARE_PLANS: 'Comparar planos',
  NO_ORG_TITLE: 'Ainda sem organização',
  NO_ORG_SUBTITLE: 'Crie uma para gerir marca e membros, ou entre com um código.',
  CREATE_PLACEHOLDER: 'Nome da organização',
  CREATE_CTA: 'Criar organização',
  JOIN_PLACEHOLDER: 'Código de adesão',
  JOIN_CTA: 'Entrar',
  MEMBER_ONLY_TITLE: 'Acesso de membro',
  MEMBER_ONLY_MESSAGE:
    'Apenas administradores da organização podem alterar marca e definições. Contacte o seu administrador se precisar de alterações.',
  MEMBER_INVITE_RETURN_TITLE: 'Já está nesta organização',
  MEMBER_INVITE_RETURN_MESSAGE:
    'Este link é para colegas que ainda precisam de entrar. Tem sessão iniciada como membro — não há nada a aceitar. Apenas administradores podem alterar marca e definições.',
  B2B_LOGO_MAX_COUNT: 1,
  BRAND_IMAGERY_SECTION_TITLE: 'Imagem de marca',
  UPLOAD_LOGOS: 'Carregar logo',
  LOGO_TILE_LABEL: 'Logo',
  LOGO_TILE_EMPTY: 'Adicionar um logo',
  BANNER_TILE_LABEL: 'Banner do squad',
  BANNER_TILE_EMPTY: 'Adicionar um banner',
  UPLOAD_BANNER: 'Carregar banner',
  REPLACE_BANNER: 'Substituir banner',
  REMOVE_BANNER: 'Remover banner',
  REMOVE_BANNER_CONFIRM_TITLE: 'Remover este banner?',
  REMOVE_BANNER_CONFIRM_MESSAGE: 'O squad voltará ao gradiente de cor da marca.',
  LOGOS_UPLOAD_LIMITS_PLACEHOLDER: '',
  LOGOS_UPLOAD_HINT:
    'PNG, JPG, WebP ou SVG. Máx. 2 MB. Quadrado (1:1), 512–1024 px de lado. PNG transparente preferido.',
  BANNER_UPLOAD_HINT:
    'PNG, JPG ou WebP. Máx. 2 MB. Proporção 4:1 — recomendado 1600×400 px, mín. 1200×300 px.',
  USE_BANNER_BACKGROUND_LABEL: 'Usar imagem do banner como fundo do squad',
  USE_BANNER_BACKGROUND_HINT:
    'Quando ativo, o hero do squad mostra a imagem do banner em vez do gradiente das cores primária/secundária.',
  USE_BANNER_BACKGROUND_DISABLED_HINT: 'Carregue primeiro uma imagem de banner para ativar esta opção.',
  USE_BANNER_BACKGROUND_SAVED: 'Guardado',
  REMOVE_LOGO: 'Remover',
  DOWNLOAD_LOGO: 'Transferir',
  DOWNLOAD_LOGO_ERROR: 'Não foi possível transferir a imagem',
  REMOVE_LOGO_CONFIRM_TITLE: 'Remover este logo?',
  REMOVE_LOGO_CONFIRM_MESSAGE: 'Deixará de aparecer para a sua organização.',
  LOGO_FILE_TOO_LARGE: 'Essa imagem excede o limite de 2 MB. Tente um ficheiro mais pequeno.',
  SAVE_COLORS: 'Guardar cores',
  COLORS_SAVED: 'Cores guardadas',
  PRIMARY: 'Primária',
  SECONDARY: 'Secundária',
  COLOR_PRESETS: 'Predefinições',
  COLOR_PALETTE_LABEL: 'Paleta',
  COLOR_PALETTE_SATURATION_A11Y: 'Saturação e brilho. Arraste para escolher a cor.',
  COLOR_PALETTE_HUE_A11Y: 'Matiz. Arraste para alterar a cor.',
  CUSTOM_HEX_LABEL: 'Personalizado (hex)',
  HEX_PLACEHOLDER: '#RRGGBB',
  JOIN_CODE: 'Código de adesão',
  SQUAD_JOIN_CODE: 'Código de adesão do squad',
  ADD_MEMBERS_TITLE: 'Adicionar colegas',
  ADD_MEMBERS_BODY:
    'Partilhe o link de convite abaixo. Os colegas iniciam sessão na Zporti e abrem o link para entrar nesta organização.',
  ADD_MEMBERS_BODY_WC_SINGLE_PRIMARY:
    'Partilhe o link de convite abaixo para os colegas iniciarem sessão e entrarem nesta organização — são adicionados automaticamente ao seu squad Football 2026 ligado. Para amigos fora da organização, partilhe um convite de squad em Football 2026 → Squads (não desta página).',
  MEMBERS_DIRECTORY: 'Diretório de membros',
  MEMBERS_ADMIN_HINT:
    'Administradores podem gerir marca, membros e definições. Use Tornar admin / Rebaixar / Remover na coluna Ações.',
  MEMBERS_TABLE_NAME: 'Nome',
  MEMBERS_TABLE_EMAIL: 'E-mail',
  MEMBERS_TABLE_ROLE: 'Função',
  MEMBERS_TABLE_JOINED: 'Entrou em',
  MEMBERS_TABLE_ACTIONS: 'Ações',
  MEMBERS_TABLE_NO_ACTIONS_VISIBLE: 'Sem ações',
  MEMBER_ACTION_LOADING_A11Y: 'A atualizar membro',
  MEMBERS_BULK_REMOVE_LOADING_A11Y: 'A remover membros selecionados',
  MEMBERS_TABLE_NO_ACTIONS_A11Y:
    'Sem ações. Não pode editar a sua própria linha, ou não há nada a alterar para este membro.',
  ROLE_LABEL_ADMIN: 'Administrador',
  ROLE_LABEL_MEMBER: 'Membro',
  MEMBERS_EMPTY: 'Ainda sem membros.',
  MEMBER_ROW_YOU_INLINE: ' (Você)',
  INVITE_LINK: 'Link de convite',
  INVITE_LINK_HINT: 'Partilhe este link para os colegas iniciarem sessão e entrarem na sua organização.',
  INVITE_LINK_HINT_WC:
    'Este link abre o fluxo de adesão à organização. Após iniciar sessão, entram na org e no seu squad Football 2026 ligado em conjunto.',
  INVITE_LINK_QR_HINT: 'Digitalize com a câmara do telemóvel para abrir este link.',
  INVITE_LINK_QR_A11Y:
    'Código QR do link de convite. Digitalize com a câmara do telemóvel para abrir a página de adesão.',
  COPY_INVITE_LINK: 'Copiar link',
  VIEW_LINKED_SQUAD: 'Ver página do squad',
  VIEW_LINKED_SQUAD_A11Y: 'Abrir o squad Football 2026 ligado para pré-visualizar resultados',
  SEATS: 'Lugares',
  SEATS_UNLIMITED: 'Ilimitados',
  MAKE_ADMIN: 'Tornar admin',
  MAKE_ADMIN_TITLE: 'Tornar este membro administrador?',
  MAKE_ADMIN_MESSAGE:
    'Poderá gerir marca, membros e definições da organização.',
  DEMOTE_ADMIN: 'Rebaixar',
  DEMOTE_ADMIN_TITLE: 'Rebaixar este administrador?',
  DEMOTE_ADMIN_MESSAGE: 'Manterá acesso como membro, mas perderá controlos de administrador.',
  REMOVE_MEMBER: 'Remover',
  MEMBERS_BULK_SELECT: 'Selecionar vários',
  MEMBERS_BULK_CANCEL_SELECT: 'Cancelar seleção',
  MEMBERS_BULK_REMOVE: 'Remover selecionados',
  MEMBERS_BULK_REMOVE_TITLE: 'Remover membros selecionados?',
  MEMBERS_BULK_REMOVE_MESSAGE:
    'Perderão acesso a esta organização (e ao squad Football 2026 ligado, se existir). Isto não pode ser desfeito.',
  MEMBERS_BULK_REMOVE_CONFIRM: 'Remover',
  MEMBERS_BULK_ROW_CHECKBOX_A11Y: 'Selecionar membro para remoção em massa',
  MEMBERS_BULK_CANCEL_DIALOG: 'Cancelar',
  MEMBERS_BULK_REMOVE_FAILED: 'Falha na remoção em massa',
  MEMBERS_INVITE_LINK_COPIED: 'Link copiado',
  membersBulkRemoveSummary: (removed: number, skipped: number) =>
    `Removidos ${removed}; ignorados ${skipped}`,
  membersBulkRemoveDone: (removed: number) => `Removidos ${removed}`,
  MEMBERS_BULK_SELECT_ALL_A11Y: 'Selecionar ou limpar todos os membros exceto você',
  ACCOUNT_NAME: 'Nome da organização',
  SAVE_NAME: 'Guardar nome',
  WC_LINKED_SQUAD_SECTION_TITLE: 'Squad Football 2026 ligado',
  WC_LINKED_SQUAD_SECTION_BODY_LINKED:
    'É o mesmo squad que vê em Football 2026 → Squads. Altere o nome do squad aqui ou nesse ecrã. Partilhe o link de convite da organização no separador Membros: novos membros entram primeiro na org, são adicionados automaticamente a este squad e depois abrem o squad.',
  WC_LINKED_SQUAD_SECTION_BODY_NOT_LINKED:
    'Cole um código de convite de squad Football 2026 para ligar esse squad a esta organização. Após ligar, quem entrar pelo link de convite da organização no separador Membros é adicionado automaticamente ao squad.',
  WC_LINKED_SQUAD_NAME_LABEL: 'Nome do squad',
  WC_LINKED_SQUAD_INVITE_CODE_LABEL: 'Código de convite do squad',
  WC_LINKED_SQUAD_CODE_PLACEHOLDER: 'Colar código de convite do squad',
  WC_LINKED_SQUAD_SAVE_NAME: 'Guardar nome do squad',
  WC_LINKED_SQUAD_LINK_SQUAD: 'Ligar squad',
  ORG_ONLY_JOIN_CODE_TITLE: 'Convite da organização',
  ORG_ONLY_JOIN_CODE_BODY:
    'Partilhe o link de convite para as pessoas entrarem primeiro na organização; são adicionadas automaticamente ao squad e podem abri-lo em Football 2026 → Squads.',
  COPY_ORG_INVITE_LINK: 'Copiar link de convite',
  PLAN_TIER: 'Plano',
  MEMBERSHIP_POLICY_TITLE: 'Limite de membros',
  MEMBERSHIP_POLICY_UNLIMITED_LABEL: 'Membros ilimitados',
  MEMBERSHIP_POLICY_UNLIMITED_APPROVED_HELP:
    'Adesões ilimitadas por link de convite estão ativas para esta organização após aprovação da Zporti.',
  MEMBERSHIP_POLICY_FROM_PLAN_HELP:
    'O seu plano inclui membros ilimitados por link de convite. Nenhuma ação necessária.',
  MEMBERSHIP_POLICY_PENDING_HELP:
    'O seu pedido está pendente. A Zporti ativará membros ilimitados após revisão.',
  MEMBERSHIP_POLICY_LIMITED_HELP:
    'Se desmarcado, adesões por link de convite são limitadas pelo seu limite de lugares (100 por defeito no Starter).',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_TITLE: 'Pedir membros ilimitados?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_MESSAGE:
    'Isto envia um pedido à Zporti. Revisaremos e ativaremos adesões ilimitadas por link de convite para a sua organização. Pode continuar a usar o limite de lugares atual até lá. Enviar o pedido agora?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_CONFIRM: 'Enviar pedido',
  MEMBERSHIP_POLICY_REQUEST_SENT: 'Pedido enviado',
  MEMBERSHIP_POLICY_CANCEL_REQUEST_LINK: 'Cancelar pedido',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_TITLE: 'Cancelar pedido de membros ilimitados?',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_MESSAGE:
    'Isto retira o seu pedido pendente. A Zporti será notificada do cancelamento.',
  MEMBERSHIP_POLICY_CANCEL_CONFIRM: 'Cancelar pedido',
  MEMBERSHIP_POLICY_CANCEL_DONE: 'Pedido cancelado',
  BILLING_GATE_LOCKED_TITLE: 'Conclua a faturação para desbloquear',
  BILLING_GATE_LOCKED_BODY:
    'Configure o plano da organização para aceder a marca, membros e definições.',
  BILLING_GATE_GO_TO_BILLING: 'Ir para o plano',
  DEACTIVATE: 'Desativar organização',
  DEACTIVATE_CONFIRM_TITLE: 'Desativar organização?',
  DEACTIVATE_CONFIRM_MESSAGE:
    'Os membros perderão benefícios da organização até o suporte reativar a organização.',
  INACTIVE_TITLE: 'Inativa',
  INACTIVE_BODY:
    'Esta organização está desativada. Pode reativá-la se foi um engano.',
  REACTIVATE: 'Reativar',
  REMOVE_MEMBER_TITLE: 'Remover membro?',
  REMOVE_MEMBER_MESSAGE: 'Perderá acesso a esta organização.',
  LEAVE_ORG_TITLE: 'Sair desta organização?',
  LEAVE_ORG_MESSAGE:
    'Perderá acesso às ferramentas de marca e membros desta org. Depois pode criar ou entrar noutra organização.',
  LEAVE_ORG_CONFIRM: 'Sair da organização',
  LEAVE_ORG_MEMBER_HINT:
    'Para deixar de usar os benefícios desta organização, pode sair. O seu administrador pode adicioná-lo novamente com um convite.',
  LEAVE_ORG_DONE_TITLE: 'Saiu da organização',
  LEAVE_ORG_DONE_MESSAGE: 'Pode criar uma nova organização ou entrar numa com um código a partir desta página.',
  LEAVE_ORG_SOLE_ADMIN_HINT:
    'É o único administrador. Promova outro membro a administrador em Membros e depois pode sair.',
  DEACTIVATE_PERMANENT_DELETE_FOOTNOTE:
    'Após desativação, aparece neste separador uma secção de eliminação permanente com campo de confirmação, abaixo de Sair da organização.',
  DELETE_ORG_SECTION_TITLE: 'Eliminar permanentemente',
  DELETE_ORG_SECTION_BODY:
    'Isto remove a organização e todas as adesões dos nossos sistemas. Escreva a frase exata abaixo: a palavra delete em minúsculas, um espaço, e depois o nome da organização exatamente como guardado.',
  DELETE_ORG_NAME_LABEL: 'Escreva esta frase exatamente',
  DELETE_ORG_BUTTON: 'Eliminar organização para sempre',
  DELETE_ORG_DIALOG_TITLE: 'Eliminar esta organização para sempre?',
  DELETE_ORG_DIALOG_MESSAGE:
    'Isto não pode ser desfeito. Todos os membros perderão acesso e os dados de marca serão removidos.',
  setupGuide: {
    TITLE: 'Ordem de configuração sugerida',
    LINE_BRANDING_BEFORE: 'Defina os seus ',
    LINE_BRANDING_LINK: 'logos e cores de marca',
    LINE_BRANDING_AFTER: ' para os membros reconhecerem a sua organização.',
    LINE_MEMBERS_BEFORE: 'Convide a sua equipa em ',
    LINE_MEMBERS_AFTER: ' usando o link de convite ou código de adesão.',
    LINE_SETTINGS_BEFORE: 'Revise o nome da organização e o plano em ',
    LINE_SETTINGS_AFTER: '.',
  },
  navShort: {
    START_HERE: 'Início',
    BRANDING: 'Marca',
    MEMBERS: 'Membros',
    SETTINGS: 'Definições',
    PLAN_BILLING: 'Plano',
    INVOICE_DETAILS: 'Faturação',
  },
  navLockedA11ySuffix: ' — conclua a faturação para desbloquear',
  brandingPreview: {
    SECTION_LABEL: 'Pré-visualização',
    SQUAD_PLACEHOLDER_NAME: 'A sua equipa',
    COMPANY_NAME_PLACEHOLDER: 'A sua organização',
    COLOR_PRIMARY_LABEL: 'Cor principal',
    COLOR_SECONDARY_LABEL: 'Cor secundária',
    HERO_BACK_LABEL: 'Equipas',
    HERO_COMPANY_GROUP_LABEL: 'Grupo empresarial',
    HERO_EMPLOYEES_LABEL: 'membros',
  },
  sso: {
    TITLE: 'Início de sessão empresarial (SSO)',
    BODY:
      'Restrinja esta organização a utilizadores com um domínio de e-mail empresarial específico. Quando ativado, novos membros que iniciem sessão com o Google usando esse domínio são adicionados automaticamente — sem link de convite. Os membros existentes não são afetados.',
    CHECKBOX_LABEL: 'Restringir ao domínio de e-mail empresarial',
    DOMAIN_PLACEHOLDER: 'acme.com',
    SAVE_BUTTON: 'Guardar definições SSO',
    INVALID_DOMAIN: 'Introduza um domínio válido (ex.: acme.com)',
    domainRestricted: (domain: string) => `Domínio restrito a @${domain}`,
    DOMAIN_REMOVED: 'Restrição de domínio removida',
    SAVE_FAILED: 'Não foi possível guardar as definições SSO',
  },
  billing: {
    ORGANIZATION_PLAN_LABEL: 'Plano da organização',
    PLAN_PICKER_HEADING: 'Escolha o seu plano',
    PLAN_PICKER_SUBHEADING:
      'Acesso organizacional único WC 2026 — marca, assentos de membros e equipa vinculada durante o torneio.',
    PLAN_BUSINESS_NAME: 'Business',
    PLAN_BUSINESS_PRICE: 'A partir de $450',
    PLAN_BUSINESS_TAGLINE:
      'Taxa org única self-service. Escolha o tier de assentos e pague uma vez pelo acesso ao torneio WC 2026.',
    ORG_BILLING_DISCLOSURE: WC2026_ORG_BILLING_DISCLOSURE,
    ORG_BILLING_DISCLOSURE_SHORT: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    PLAN_BUSINESS_CTA: 'Começar',
    PLAN_ENTERPRISE_NAME: 'Enterprise',
    PLAN_ENTERPRISE_PRICE: 'Personalizado',
    PLAN_ENTERPRISE_TAGLINE:
      'Preços personalizados para grandes organizações. Contacte-nos e criaremos um plano adequado.',
    PLAN_ENTERPRISE_CTA: 'Contacte-nos',
    CUSTOM_FORM_NAME_LABEL: 'O seu nome',
    CUSTOM_FORM_NAME_PLACEHOLDER: 'Jane Smith',
    CUSTOM_FORM_EMAIL_LABEL: 'E-mail profissional',
    CUSTOM_FORM_EMAIL_PLACEHOLDER: 'jane@company.com',
    CUSTOM_FORM_MESSAGE_LABEL: 'Mensagem (opcional)',
    CUSTOM_FORM_MESSAGE_PLACEHOLDER: 'Fale-nos da sua organização e do que precisa.',
    CUSTOM_FORM_SUBMIT: 'Enviar pedido',
    CUSTOM_FORM_SENT: 'Entraremos em contacto em breve!',
    PERSONAL_PLAN_LABEL: 'Plano pessoal',
    ENTERPRISE_QUOTE_LABEL: 'Preço Enterprise acordado',
    MANAGE_PORTAL: 'Gerir faturação da organização',
    MANAGE_PERSONAL_PORTAL: 'Gerir subscrição pessoal',
    COMPARE_PLANS: 'Comparar planos',
    SUBSCRIPTION_STATUS: 'Estado da subscrição',
    PERIOD_END: 'Renova ou termina o período',
    PERSONAL_BILLING_SECTION: 'Subscrição pessoal',
    ORG_BILLING_SECTION: 'Subscrição da organização',
    STRIPE_NOT_CONFIGURED:
      'A faturação está a ser configurada. Os detalhes do plano estarão disponíveis em breve.',
    B2B_BILLING_RETURN_SYNCING: 'A aplicar o seu pagamento Stripe…',
    B2B_BILLING_RETURN_SYNCING_A11Y: 'A aplicar o seu pagamento Stripe',
    ORG_SEAT_TIER_LABEL: 'Nível de lugares',
    ORG_CURRENT_SEAT_TIER_LABEL: 'Nível de lugares atual',
    UPGRADE_SEAT_TIER: 'Atualizar',
    SEAT_TIER_UPGRADE_DIALOG_TITLE: 'Atualizar nível de lugares?',
    SEAT_TIER_UPGRADE_DIALOG_CONFIRM: 'Continuar para pagamento',
    SEAT_TIER_UPGRADE_DIALOG_CANCEL: 'Cancelar',
    SEAT_TIER_UPGRADE_DIALOG_CURRENT_PREFIX: 'Nível de lugares atual:',
    SEAT_TIER_UPGRADE_DIALOG_TARGET_PREFIX: 'A atualizar para:',
    SEAT_TIER_UPGRADE_DIALOG_REFUND_BODY:
      'Já pagou pelo seu nível de lugares atual (inferior). A Stripe creditará ou reembolsará a parte não utilizada desse valor para esta atualização — o pagamento reflete o montante líquido (rateio).',
    SEAT_TIER_UPGRADE_DIALOG_SCOPE_REMINDER: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    SEAT_TIER_UPGRADE_DIALOG_CONTINUE_PROMPT: 'Continuar?',
    NEED_CUSTOM_PLAN: 'Precisa de um plano personalizado?',
    NEED_CUSTOM_PLAN_A11Y: 'Plano personalizado',
    PLAN_TIER_STARTER: 'Starter (grátis)',
    PLAN_TIER_PRO: 'Pro',
    PLAN_TIER_BUSINESS: 'Business',
    PLAN_TIER_ENTERPRISE: 'Enterprise',
    SUBSCRIPTION_STATUS_ACTIVE: 'Ativa',
    SUBSCRIPTION_STATUS_TRIALING: 'Em teste',
    SUBSCRIPTION_STATUS_PAST_DUE: 'Em atraso',
    SUBSCRIPTION_STATUS_CANCELED: 'Cancelada',
    SUBSCRIPTION_STATUS_UNPAID: 'Por pagar',
    SUBSCRIPTION_STATUS_INCOMPLETE: 'Incompleta',
    SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: 'Expirada',
    SUBSCRIPTION_STATUS_PAUSED: 'Em pausa',
  },
} as const
